import { render, staticRenderFns } from "./ButtonItemEdit.vue?vue&type=template&id=cf513188&"
import script from "./ButtonItemEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports